export function getDownPaymentInPercents(price: number, downPayment: number) {
  const percents = Math.round((downPayment / price) * 100) || 0;

  return Math.min(percents, 100);
}
